import { Utility, getTargetContainers, utility_controller } from '../utility/utility_controller'
import mobile_menu_controller from '../mobile/mobile_menu_controller'
import { hideAllOverlays } from '../page_overlay/page_overlay'
import projects_overlays from '../projects_overlays/projects_overlays'
import element_animate_in_on_scroll_controller from '../element_animate_in_on_scroll/element_animate_in_on_scroll'
import element_animate_in_on_scroll_for_pageoverlays from '../element_animate_in_on_scroll/element_animate_in_on_scroll_for_pageoverlays.js'
import expandrow_controller from '../expandrow/expandrow_controller'
import history_controller from '../history/history_controller_new'
var $target = undefined

// todo: see if fullscreen slider is currently active √
// todo: if so, scroll to slide with certain anchor √
// todo: also do this on init √
// todo: test if this works when switching between mobile and desktop view if fullscreen slider is disabled for mobile view √
// todo: test if fullscreen slider behaviour works when coming from a non fs page √
// todo: test if link to a different page that has an anchor works

var getFullScreenSliderType = function () {
	// Use the setting from magneticSlidesPassedData to determine slider type and direction
	if (typeof magneticSlidesPassedData !== 'undefined' && magneticSlidesPassedData.ms_slide_type) {
		// Check if slider is actually active on the page (has the classes)
		var isActive = jQuery('.vertical-fullpage, .horizontal-fullpage, .vertical-scrollsnap, .horizontal-scrollsnap').length > 0

		if (isActive && magneticSlidesPassedData.ms_direction) {
			// Return direction based on setting (works for both fullpage.js and css_scroll_snap)
			return magneticSlidesPassedData.ms_direction
		}
	}
	return 'none'
}

// gets the index of the row that contains an element with the id of "hash", or row has the id of "hash"
var getRowIndexByHash = function (hash) {
	if (typeof $target != 'undefined') {
		var $el = resolveHashTarget(hash, null)

		var $row = $el.closest('.row')

		if ($row.length == 0) {
			console.error('no row found')
			return 0
		}
		var $rows = $target.find('.row')

		var index = $rows.index($row)

		return index
	}
	return 0
}

var normalizeHostForComparison = function (host) {
	return (host || '').replace(/^www\./i, '').toLowerCase()
}

var normalizePathForComparison = function (path) {
	path = path || '/'
	// WordPress links can contain more than one slash before the hash
	// (for example /project//#anchor). Treat those like the canonical
	// trailing-slash URL so same-page anchors still work in overlays.
	path = path.replace(/\/+$/, '')
	return path == '' ? '/' : path
}

var urlsPointToSamePage = function (href) {
	try {
		var currentUrl = new URL(window.location.href)
		var linkUrl = new URL(href, window.location.href)
		return (
			normalizeHostForComparison(linkUrl.host) == normalizeHostForComparison(currentUrl.host) &&
			normalizePathForComparison(linkUrl.pathname) == normalizePathForComparison(currentUrl.pathname) &&
			linkUrl.search == currentUrl.search
		)
	} catch (e) {
		return false
	}
}

var isAnchorLinkToSamePage = function ($anchor) {
	// the href in $anchor always contains a #!

	// does link start with # ?
	if ($anchor.attr('href').substr(0, 1) == '#') {
		return true
	}
	if ($anchor[0].hasAttribute('data-id') && $anchor[0].hasAttribute('data-type')) {
		if ($anchor.attr('data-id') == jQuery('body').attr('data-id') && $anchor.attr('data-type') == jQuery('body').attr('data-type')) {
			return true
		}
	}
	if (urlsPointToSamePage($anchor.attr('href'))) {
		return true
	}
	return false
}

var getAnchorScrollAnimationOptions = function () {
	var duration = parseInt(layData.anchorscroll_duration, 10)
	if (!jQuery.isNumeric(duration) || duration < 0) {
		duration = 300
	}

	var easing = layData.anchorscroll_easing
	if (typeof easing !== 'string' || easing === '') {
		easing = 'easeInOutQuad'
	}
	if (typeof jQuery.easing !== 'object' || typeof jQuery.easing[easing] === 'undefined') {
		easing = 'swing'
	}

	return {
		duration: duration,
		easing: easing,
	}
}

var shouldAddAnchorHashToUrl = function () {
	return layData.anchorscroll_disable_url_hash != 'on'
}

var replaceAnchorHashInUrl = function (hash) {
	if (shouldAddAnchorHashToUrl()) {
		history_controller.replaceState(hash)
	}
}

var replaceProjectOverlayAnchorHashInUrl = function (hash) {
	if (shouldAddAnchorHashToUrl()) {
		history_controller.replaceCurrentStateHash(hash)
	}
}

// Resolve the element a hash points at. The same id can legitimately appear
// more than once in the DOM:
//  - a page rendered both normally and inside an overlay (separate .lay-content)
//  - a Custom Phone Layout, where the id lives once in the desktop #grid and
//    once in #custom-phone-grid — BOTH inside the SAME .lay-content, so
//    narrowing by .lay-content alone does not disambiguate.
// Narrow by the clicked anchor's .lay-content first, then, if still ambiguous,
// pick the element that is actually visible (the inactive breakpoint's copy is
// display:none and has no layout box, so :visible resolves the CPL case).
var resolveHashTarget = function (hash, clickedAnchor) {
	var el = $target.find(hash)
	if (el.length <= 1) {
		return el
	}
	if (clickedAnchor && typeof clickedAnchor.closest === 'function') {
		var closestLayContent = clickedAnchor.closest('.lay-content')
		if (closestLayContent) {
			var scoped = jQuery(closestLayContent).find(hash)
			if (scoped.length > 0) {
				el = scoped
			}
		}
	}
	if (el.length > 1) {
		for (var i = 0; i < el.length; i++) {
			if (jQuery(el[i]).is(':visible')) {
				return jQuery(el[i])
			}
		}
	}
	return el
}

// WordPress puts custom menu classes on the menu item's <li>, while custom
// markup may put them directly on the link or a menu wrapper. Support all three
// placements so a menu can opt in without requiring custom JavaScript.
var shouldCollapseExpandedRowsBeforeScroll = function (clickedAnchor) {
	var $anchor = jQuery(clickedAnchor)
	return $anchor.hasClass('lay-collapse-expanded-rows') || $anchor.closest('.lay-collapse-expanded-rows').length > 0
}

// Sticky covers stay at the top of the viewport while their inner element can
// also be translated for the cover parallax effect. jQuery.offset() includes
// both visual effects, so an anchor inside the cover appears to be near the
// current scroll position instead of at its static position in the document.
var getWindowAnchorTargetTop = function ($el) {
	var $coverRegion = $el.closest('.cover-region')
	if ($coverRegion.length > 0) {
		var top = 0
		var element = $el[0]
		while (element && element !== $coverRegion[0]) {
			top += element.offsetTop || 0
			element = element.offsetParent
		}
		return top
	}
	return $el.offset().top
}

var initAnchorScroll = function () {
	// all hrefs that contain a # but not #search

	// todo: test if i can link to an external website that has a hash?
	// this used to be: "a[href^="#"]" but now it is "a[href*="#"]" (difference is *=, not ^=)
	// thats why now links work that point to the same page but are not #hey but www.hey.com/samepage#hey
	// however, now links that link to a different page also scroll, instead of using a history push.
	// so what i need to do is:
	// check if this link is a link to the current page. if it is, do the scroll. if it is not, do the history push
	// only target anchors in .lay-content because plugins might use hash-type anchors that should not be bound
	// like for example borlands cookie consent plugin!

	// doing :not([href="#"]) because "borlands cookie consent plugin" uses that type of href for its "load" youtube video button
	jQuery(document).on('click', '.lay-content a[href*="#"]:not([href="#search"]):not([href="#"]):not([href="#laynextproject"]):not([href="#layprevproject"]):not(.scrolltotop), ' + '.laynav a[href*="#"]:not([href="#search"]):not([href="#laynextproject"]):not([href="#layprevproject"]):not(.scrolltotop)', function (e) {
		var href = jQuery(this).attr('href')
		var hash_character_position = href.indexOf('#')
		var hash = href.substring(hash_character_position)
		if (hash.indexOf('&') != -1 || hash.indexOf('?') != -1 || hash.indexOf('=') != -1) {
			return
		}

		// don't do it if fullpage circle is clicked
		if (jQuery(this).closest('#fp-nav').length > 0 || jQuery(this).closest('.fp-slidesNav').length > 0) {
			e.preventDefault()
			return
		}
		// don't scroll on same page if link is link to a different page!
		if (!isAnchorLinkToSamePage(jQuery(this))) {
			// if link contains an anchor, it does not have data-type or data-id attributes, so we cannot do a history push
			// instead, we just do a normal page-load
			return
		}

		// prevent a normal page load!
		e.preventDefault()
		// if on mobile, hide mobile menu
		mobile_menu_controller.hideMobileMenu()

		if ($target == undefined || $target.length == 0) {
			return
		}
		var el = resolveHashTarget(hash, e.target)
		var collapseWait = 0
		if (el.length != 0 && shouldCollapseExpandedRowsBeforeScroll(this)) {
			collapseWait = expandrow_controller.collapseAllExpandedRows(el.closest('.grid'))
		}

		var doAnchorScroll = function () {
			var fullscreenSliderType = getFullScreenSliderType()
			// fullscreenSliderType can be: none = not active, horizontal, vertical

			// when element to scroll to is inside an overlay, use normal overlay scrolling instead of a fullscreen slider from the underlay
			if (jQuery(el).closest('.lay-overlay, #lay-project-overlay').length > 0) {
				fullscreenSliderType = 'none'
			}

			// test
			switch (fullscreenSliderType) {
			case 'none':
				if (el.length != 0) {
					var animationOptions = getAnchorScrollAnimationOptions()
					if (jQuery(el).closest('.lay-overlay').length > 0) {
						// this is for a page overlay
						var top = el.offset().top
						top = addSpaceTop(top)
						// if we are inside a page overlay, we need to substract window.scrollY
						top -= window.scrollY
						// do not animate body but only html. this way we prevent a scrolling bug where an upper part of the website would be cut off
						jQuery(el)
							.closest('.lay-content')
							.animate(
								{
									scrollTop: top,
								},
								animationOptions.duration,
								animationOptions.easing,
								function () {
									// i just don't set the hash when we're in a page overlay :)
								}
							)
					} else {
						utility_controller.unfixBody()
						// timeout so on safari the animation isnt janky :)
						setTimeout(function () {
							hideAllOverlays()
						}, 0)

						// If we use the splitscreen layout, we need to scroll the containers instead of the html element
						if (layData.never_change_scrolling_position == 'on' && Utility.screenSize != 'phone') {
							var top = el[0].getBoundingClientRect().top

							let $scrollTarget
							if (projects_overlays.isOverlayDisplayBlock()) {
								$scrollTarget = jQuery('#lay-project-overlay #grid')
							} else {
								$scrollTarget = jQuery('body>.lay-content #grid')
							}

							if (jQuery(el).closest('#footer-region').length > 0) {
								$scrollTarget = jQuery('#footer-region')
							}

							top += $scrollTarget[0].scrollTop
							top = addSpaceTop(top)

							$scrollTarget.animate(
								{
									scrollTop: parseInt(top, 10),
								},
								animationOptions.duration,
								animationOptions.easing,
								function () {
									// usually i would set the hash here, but when using splitscreen, it doesn't seem to work too well
									// so i just don't set the hash when we're in splitscreen :). it would like go to the wrong scroll position, even when i set the scroll position after
									// SO DONT DO THIS FOR NOW:
									// window.location.hash = hash
									// window.scroll(0, top)
									// re-setting scroll position here, because otherwise, setting the hash would just set the browser's default position without the added space top (function addSpaceTop)
									// $scrollTarget[0].scroll(0, top)
									expandrow_controller.expand_on_anchorscroll()
								}
							)
						} else {
							var isProjectOverlay = projects_overlays.isOverlayDisplayBlock()
							var animationTargetStr = isProjectOverlay ? '#lay-project-overlay' : 'html'
							var $animationTarget = jQuery(animationTargetStr)
							var top

							if (isProjectOverlay) {
								// Calculate an absolute scroll position inside the overlay. Using only
								// the target's document offset loses the overlay's current scrollTop.
								var overlayElement = $animationTarget[0]
								top = el[0].getBoundingClientRect().top - overlayElement.getBoundingClientRect().top + overlayElement.scrollTop
								top = addSpaceTop(top)
							} else {
								// We don't use the splitscreen layout, so scroll the html element.
								top = getWindowAnchorTargetTop(el)
								top = addSpaceTop(top)
							}

							$animationTarget.animate(
								{
									scrollTop: parseInt(top, 10),
								},
								animationOptions.duration,
								animationOptions.easing,
								function () {
									if (isProjectOverlay) {
										replaceProjectOverlayAnchorHashInUrl(hash)
									} else {
										replaceAnchorHashInUrl(hash)
										// re-setting scroll position here, because otherwise, setting the hash would just set the browser's default position without the added space top (function addSpaceTop)
										window.scroll(0, parseInt(top, 10))
									}
									expandrow_controller.expand_on_anchorscroll()
								}
							)
						}
					}
				}
				break
			case 'vertical':
				utility_controller.unfixBody()
				// timeout so on safari the animation isnt janky :)
				setTimeout(function () {
					hideAllOverlays()
				}, 0)
				// here i dont care about "addSpaceTop"
				var rowIndex = getRowIndexByHash(hash)
				var sectionIndex = rowIndex + 1
				// this is for when we reload:
				// jQuery(window).one('fpAfterRender', function () {
				// 	jQuery(window).one('fpAfterLoad', function () {
				// 		history_controller.replaceState(hash)
				// 	})
				// 	jQuery.fn.fullpage.moveTo(sectionIndex, 0)
				// })

				// this is for when we are on the page already!
				// For fullpage.js, wait for fpAfterLoad event
				// For CSS scroll snap, update hash immediately after moveTo (events are not triggered for scroll snap)
				if (typeof magneticSlidesPassedData !== 'undefined' && magneticSlidesPassedData.ms_slide_type === 'css_scroll_snap') {
					jQuery.fn.fullpage.moveTo(sectionIndex, 0)
					// For CSS scroll snap, update hash after a short delay to allow scroll to complete
					setTimeout(function () {
						replaceAnchorHashInUrl(hash)
					}, 300)
				} else {
					jQuery(window).one('fpAfterLoad', function () {
						replaceAnchorHashInUrl(hash)
					})
					jQuery.fn.fullpage.moveTo(sectionIndex, 0)
				}
				expandrow_controller.expand_on_anchorscroll()
				break
			case 'horizontal':
				utility_controller.unfixBody()
				// timeout so on safari the animation isnt janky :)
				setTimeout(function () {
					hideAllOverlays()
				}, 0)
				// here i dont care about "addSpaceTop"
				var rowIndex = getRowIndexByHash(hash)
				var slideIndex = rowIndex
				// this is for when we reload:
				// jQuery(window).one('fpAfterRender', function () {
				// 	jQuery(window).one('fpAfterSlideLoad', function () {
				// 		history_controller.replaceState(hash)
				// 	})
				// 	jQuery.fn.fullpage.moveTo(1, slideIndex)
				// })

				// this is for when we are on the page already!
				// For fullpage.js, wait for fpAfterSlideLoad event
				// For CSS scroll snap, update hash immediately after moveTo (events are not triggered for scroll snap)
				if (typeof magneticSlidesPassedData !== 'undefined' && magneticSlidesPassedData.ms_slide_type === 'css_scroll_snap') {
					jQuery.fn.fullpage.moveTo(1, slideIndex)
					// For CSS scroll snap, update hash after a short delay to allow scroll to complete
					setTimeout(function () {
						replaceAnchorHashInUrl(hash)
					}, 300)
				} else {
					jQuery(window).one('fpAfterSlideLoad', function () {
						replaceAnchorHashInUrl(hash)
					})
					jQuery.fn.fullpage.moveTo(1, slideIndex)
				}
				expandrow_controller.expand_on_anchorscroll()
				break
			}
		}

		if (collapseWait > 0) {
			setTimeout(doAnchorScroll, collapseWait)
		} else {
			doAnchorScroll()
		}
	})
}

var addSpaceTop = function (top) {
	switch (Utility.screenSize) {
		case 'desktop':
		case 'tablet':
			var navbarHeight = 0
			jQuery('.lay-navbar.position-top:visible').each(function () {
				navbarHeight = Math.max(navbarHeight, jQuery(this).outerHeight())
			})
			top -= navbarHeight
			if (layData.anchorscroll_offset_desktop != '' && jQuery.isNumeric(parseInt(layData.anchorscroll_offset_desktop, 10))) {
				top -= parseInt(layData.anchorscroll_offset_desktop, 10)
			}
			break
		case 'phone':
			if (jQuery('.navbar').is(':visible') && layData.mobile_navbar_fixed == '1') {
				top -= parseInt(jQuery('.navbar').height(), 10)
			}
			if (layData.anchorscroll_offset_phone != '' && jQuery.isNumeric(parseInt(layData.anchorscroll_offset_phone, 10))) {
				top -= parseInt(layData.anchorscroll_offset_phone, 10)
			}
			break
	}
	return top
}

var handleHashAfterContentReady = function (hashOverride) {
	var hash = hashOverride || window.location.hash
	if (hash.indexOf('&') != -1 || hash.indexOf('?') != -1 || hash.indexOf('=') != -1) {
		return ''
	}
	var el = resolveHashTarget(hash, null)
	// scroll to
	if (el.length > 0) {
		var fullscreenSliderType = getFullScreenSliderType()
		switch (fullscreenSliderType) {
			case 'none':
				var top = getWindowAnchorTargetTop(el)
				top = addSpaceTop(top)

				// If we use the splitscreen layout, we need to scroll the containers instead of the html element
				if (layData.never_change_scrolling_position == 'on' && Utility.screenSize != 'phone') {
					let $scrollTarget
					if (projects_overlays.isOverlayDisplayBlock()) {
						$scrollTarget = jQuery('#lay-project-overlay #grid')
					} else {
						$scrollTarget = jQuery('body>.lay-content #grid')
					}
					if (jQuery(el).closest('#footer-region').length > 0) {
						// jQuery(el).closest('#footer-region') , using .closest, because the footer region could be parent of #lay-project-overlay
						$scrollTarget = jQuery(el).closest('#footer-region')
					}
					$scrollTarget[0].scroll(0, top)
					expandrow_controller.expand_on_anchorscroll()
				} else {
					// we don't use the splitscreen layout, so we can scroll the html element
					window.scroll(0, top)
					expandrow_controller.expand_on_anchorscroll()
				}
				break
			case 'vertical':
				// here i dont care about "addSpaceTop"
				var rowIndex = getRowIndexByHash(hash)
				var sectionIndex = rowIndex + 1
				jQuery.fn.fullpage.silentMoveTo(sectionIndex, 0)
				// need to scroll to 0
				if (magneticSlidesPassedData.ms_autoScrolling == 'on' && magneticSlidesPassedData.ms_scrollBar == '') {
					window.scrollTo(0, 0)
				}
				expandrow_controller.expand_on_anchorscroll()
				break
			case 'horizontal':
				// here i dont care about "addSpaceTop"
				var rowIndex = getRowIndexByHash(hash)
				var slideIndex = rowIndex
				jQuery.fn.fullpage.silentMoveTo(1, slideIndex)
				// need to scroll to 0
				// if (magneticSlidesPassedData.ms_autoScrolling == 'on' && magneticSlidesPassedData.ms_scrollBar == '') {

				window.scrollTo(0, 0)
				// }
				expandrow_controller.expand_on_anchorscroll()
				break
		}
		return hash
	}
	return ''
}

var bindOnHashChange = function () {
	var lastPathname = window.location.pathname
	var lastHash = window.location.hash

	jQuery(window).on('hashchange', function () {
		var hash = window.location.hash
		var currentPathname = window.location.pathname

		// Check if pathname changed (e.g., going back from /cart/ to /#one)
		if (currentPathname !== lastPathname) {
			// Pathname changed - this means we navigated to a different page
			// Use setTimeout to allow history listener to update first, then check state
			setTimeout(function () {
				var stateObj = null
				if (window.layHistory && window.layHistory.location && window.layHistory.location.state) {
					stateObj = window.layHistory.location.state
				}

				var currentType = jQuery('body').attr('data-type')
				var currentId = jQuery('body').attr('data-id')

				// If we have a state object and it matches current page, we're on the right page
				// Otherwise, we need to reload
				if (stateObj && stateObj.type == currentType && stateObj.id == currentId) {
					// Already on the right page, just scroll to anchor
					lastPathname = currentPathname
					lastHash = hash
					if ($target != undefined) {
						handleHashAfterContentReady()
					}
				} else {
					// Not on the right page - do a full reload
					lastPathname = currentPathname
					lastHash = hash
					// Use pathname || '/' so myurl.com#hello works like myurl.com/#hello
					window.location.href = (currentPathname || '/') + window.location.search + hash
				}
			}, 0)
			return
		}

		// Same pathname, just hash changed - scroll to anchor
		// But only if hash actually changed (avoid duplicate triggers)
		if (hash !== lastHash) {
			lastPathname = currentPathname
			lastHash = hash
			if ($target != undefined) {
				handleHashAfterContentReady()
			}
		}
	})
}

var i = function () {
	initAnchorScroll()
	bindOnHashChange()
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		$target = undefined
		$target = getTargetContainers(typeOfContentThatIsReady)
		// When we navigated from another page with an anchor (initialHash), replace current entry with path+hash so one Back returns to previous page
		var initialHash = ''
		if (shouldAddAnchorHashToUrl()) {
			history_controller.applyInitialHashAndReplace()
		} else {
			initialHash = history_controller.consumeInitialHashWithoutReplace()
		}
		// wait 50 ms until masonry might have initialized
		setTimeout(function () {
			var handledHash = handleHashAfterContentReady(initialHash)
			// A normal cross-page anchor link performs a full page load, so it
			// cannot use the transient initialHash state from AJAX navigation.
			// Keep the hash long enough to find and scroll to the target, then
			// remove it without adding another browser-history entry.
			if (!shouldAddAnchorHashToUrl() && handledHash && window.location.hash == handledHash) {
				history_controller.removeCurrentHash()
			}
		}, 50)
	})
}

var anchor_behaviour_controller = {
	i: i,
	addSpaceTop: addSpaceTop,
}

export default anchor_behaviour_controller
